export default "__VITE_ASSET__DgAOEEva__"